// Browser side of the cookie session: the login token lives in an HttpOnly cookie that scripts can't read.
// Every call to our API carries the cookie automatically, plus the CSRF value echoed in a header on writes.
import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const SAFE = new Set(['GET', 'HEAD', 'OPTIONS']);
// Non-secret marker kept for older screens that only check "is someone signed in?"
export const SESSION_MARKER = 'cookie';

export const readCsrf = () => {
  const m = document.cookie.match(/(?:^|;\s*)fbc_csrf=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : '';
};

const isApi = (url) => typeof url === 'string' && (url.startsWith(`${API_BASE}/api`) || url.startsWith('/api'));

export function installSessionClient() {
  axios.defaults.withCredentials = true;
  axios.interceptors.request.use((config) => {
    if (isApi(config.url)) {
      config.headers = config.headers || {};
      config.headers['X-FBC-Client'] = 'web';
      if (!SAFE.has((config.method || 'get').toUpperCase())) config.headers['X-CSRF-Token'] = readCsrf();
      const auth = config.headers.Authorization || config.headers.authorization;
      if (typeof auth === 'string' && /^Bearer (cookie|null|undefined)?$/.test(auth.trim())) {
        delete config.headers.Authorization; delete config.headers.authorization;
      }
    }
    return config;
  });
  const nativeFetch = window.fetch.bind(window);
  window.fetch = (input, init = {}) => {
    const url = typeof input === 'string' ? input : input?.url;
    if (!isApi(url)) return nativeFetch(input, init);
    const headers = new Headers(init.headers || (typeof input !== 'string' ? input.headers : undefined));
    headers.set('X-FBC-Client', 'web');
    const method = (init.method || (typeof input !== 'string' ? input.method : 'GET') || 'GET').toUpperCase();
    if (!SAFE.has(method)) headers.set('X-CSRF-Token', readCsrf());
    if (/^Bearer (cookie|null|undefined)?$/.test((headers.get('Authorization') || '').trim())) headers.delete('Authorization');
    return nativeFetch(input, { ...init, headers, credentials: 'include' });
  };
}

// Legacy helper for code that used to read the token from sessionStorage.
export const authMarker = () => (sessionStorage.getItem('fbc_signed_in') ? SESSION_MARKER : null);
